import React, { useEffect, useRef, useState } from 'react';
import type { ColumnsType, TablePaginationConfig } from 'antd/es/table';
import { Select, Spin, Table, notification } from 'antd';
import { deleteWorkOrder, fetchMyWorkOrderList, fetchSOWDetails, fetchSOWandClient, fetchWorkOrderList, setPOMappingModalIsOpen, setWorkOrderModalIsOpen, setWorkOrderSelectedSOW, triggerParentId } from '../../store/reducers/orderDashboardSlice';
import { useDispatch, useSelector } from 'react-redux';
import { rejectedApiMessage } from '../../utilities/CommonHelper';
import FloatLabel from '../../components/FloatLabel/floatLabel';
import DataTable from '../../components/DataTable/DataTable';
import moment from 'moment';
import WorkOrderAuditLog from '../WorkOrderAuditLog/workOrderAuditLog';

interface Props {
 activeTab: string;
 refreshTable: boolean;
 handleRefreshTable: (value: boolean) => void;
}
interface DataType {
 key: React.Key;
 orderId: string;
 clientEntity: string;
 bu: string;
 department: string;
 parentId: string;
 indegeneEntity: string;
}
const form_fields: {
 label: string;
 placeholder: string;
 id: string;
 required: boolean;
 disabled: boolean,
 options?: { label: string, value: string }[];
 type: 'textbox' | 'selectDropdown' | 'multilineTextbox'
}[] = [
   {
     label: 'Client Name ',
     placeholder: 'Indegene',
     id: 'clientEntity',
     required: true,
     disabled: false,
     type: 'selectDropdown',
     options: [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]

   },
   {
     label: 'SOW ',
     placeholder: 'Enter BU',
     id: 'BuName',
     required: true,
     disabled: false,
     type: 'selectDropdown',
     options: [{ label: 'Something1', value: 'something1' }, { label: 'Something2', value: 'Something2' }, { label: 'Something3', value: 'Something3' }, { label: 'Something 4', value: 'Something4' }, { label: 'Something 5', value: 'Something5' }]

   }
 ]

  
const MyWorkOrdersTab: React.FC<Props> = ({activeTab, refreshTable, handleRefreshTable}) => {
const dispatch = useDispatch();
const orderDashboardData = useSelector((state: any) => state.orderDashboard);
 const [workorderDataList, setWorkorderDataList] = useState<any>([]);
 const [selectedWorkOrder, setSelectedWorkOrder] = useState<any>({});
 const [viewAuditlogModal, setViewAuditlogModal] = useState<boolean>(false);
 const selectRef = useRef<any>(null);

const fetchMyWorkOrderData=()=>{
  console.log("fetchMyWorkOrderData");  
  dispatch(fetchMyWorkOrderList()).then((response: any) => {
    if (response.type !== 'orderDashboard/fetchMyWorkOrderList/fulfilled') {
      rejectedApiMessage(response.payload);
    }
    else{
      let temp : any[]= response.payload;
      temp = temp.sort((a:any, b:any) => moment(b.lastModifiedDate, 'YYYY-MM-DD').diff(moment(a.lastModifiedDate, 'YYYY-MM-DD')))
      setWorkorderDataList(temp);

    }
  });
}
  useEffect(() => {
    if(activeTab === '3'){

    fetchMyWorkOrderData();
    }
    else{
      setWorkorderDataList([]);
      setSelectedWorkOrder({});
    }

  },[activeTab]);

  useEffect(() => {
    console.log("refreshTable",refreshTable);
    if(refreshTable){
      handleRefreshTable(false);
      fetchMyWorkOrderData();
    }
  },[refreshTable]);

const handleEditWorkOrder= (row:any) => {
  console.log("handleEditWorkOrder starting",row);
      dispatch(setWorkOrderModalIsOpen({isModalOpen:true,selectedWorkOrder:row,type:'edit'}));
    
}
const handleDeleteWorkOrder =(row:any) => {
  // console.log("handleDeleteWorkOrder",row);

      dispatch(deleteWorkOrder({workOrderId:row.id})).then((response: any) => {
        if (response.type !== 'orderDashboard/deleteWorkOrder/fulfilled') {
          rejectedApiMessage(response.payload);
        }
        else{
          notification.success({message: 'Success', description:'Work Order Deleted Successfully.'})
          fetchMyWorkOrderData();
      
        }
      });
  
}
const handleMapUnmapPO =(row:any) => {

  dispatch(setPOMappingModalIsOpen({isModalOpen:true,selectedWorkOrder:row}));
  
  
}

const handleParentIdTrigger =(row:any) => {

  dispatch(triggerParentId({workOrderId:row.id})).then((response: any) => {
    if (response.type !== 'orderDashboard/triggerParentId/fulfilled') {
      rejectedApiMessage(response.payload);
      fetchMyWorkOrderData();
    }
    else{
      notification.success({message: 'Success', description:'Parent Id Generated Successfully.'})
      fetchMyWorkOrderData();
    }
  });
  
}

const handleWorkOrderHistory =(row:any) => {
  setSelectedWorkOrder(row);
  setViewAuditlogModal(true)
}

  return (
        <Spin spinning={orderDashboardData?.loading} tip="Loading..."><div>

<div 
// style={{ background: '#F2F6FA', margin: '15px', padding: '15px' }}
>
      <div className="form-component" style={{ maxWidth: '100%' }}>
          <DataTable
          handleDeleteWorkOrder={(row:any) => handleDeleteWorkOrder(row)}
          handleEditWorkOrder={(row:any) => handleEditWorkOrder(row)}
          handleMapUnmapPO={(row:any) => handleMapUnmapPO(row)}
          handleParentIdTrigger={(row:any) => handleParentIdTrigger(row)}
          handleWorkOrderHistory={(row:any) => handleWorkOrderHistory(row)}
          data={workorderDataList} />
      </div>

    </div>
    
   </div>
   <WorkOrderAuditLog visible={viewAuditlogModal} onCancel={()=>{setViewAuditlogModal(false); setSelectedWorkOrder({})}} selectedWorkOrder={selectedWorkOrder} />

    </Spin>
  );
};

export default MyWorkOrdersTab;
